import { IComponentController, IWindowService } from 'angular';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IAccesManager } from '../../../../../core/services/acces-manager.service';
import { IFilterLibelle } from '../../../../../core/filters/ex-libelle.filter';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IApiConfig } from "../../../../../core/interfaces/api-config.interface";
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { INotificationHandler } from '../../../../../core/services/utils/notification-handler.service';
import { IApiError } from '../../../../../core/interfaces/api-error.interface';
import IDialogService = angular.material.IDialogService;
import { IDialogAllStatus } from '../../../../../core/constants/dialog.constant';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';


interface IPageDo0070 extends IComponentController {
    monoOccurrence: IMonoOccurrence; // Données du formulaire accessibles via l'attribut "successAction" un bouton du MenuItemAction de sauvegarde par defaut du formulaire
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    valeursEcran: any;
    etwFormulaire: IMonoOccurrence; // Données du formulaire accessibles via l'attribut "successActionSauvegarde" du bouton de sauvegarde par defaut du formulaire
    icones: IIconnes;
    formData: any;
}

interface IIconnes {
    telephonePrincipal: string,
    telephoneUrgence: string,
    informationBancaires: string,
    information: string,
    courriel: string,
    adresseDomicile: string,
    feedback: string,
    motdepasse: string,
    questionSecrete: string,
    nomPrenom: string,
    fax: string,
    warning: string
}

interface IEtw { // Représente l'entité Etudiant
    etwcleint: number; // Clé interne
    etwnummat: string; // Code permanent
    etwnom: string; // Nom
    etwprn: string; // Prénom
    vaeeplsex: string; // Sexe
    etwdatnai: string; // Date de naissance
    etwnas: string; // NAS étudiant
    etwflgimm: number; // Indicateur étudiant étranger ?
    etwnasimm: string; // NAS étudiant étranger
    etwadrcou: string; // Courriel
    etwnumtel: string; // Numéro de téléphone
    etwadrl01: string; // Adresse 1
    etwadrl02: string; // Adresse 2
    etwadrl03: string; // Adresse 3
    etwvil: string; // Ville
    etwpro: string; // Province
    etwpay: string; // Pays
    etwcodpos: string; // Code postal
    etwdatper: string; // Date du permis (Étudiant étranger)
    etwdatexp: string; // Date d'expiration du permis (Étudiant étranger)
    urlportail: string; // url du portail
    simulation: number; 
    eplnummat: string; // Matricule employé
}


/* @ngInject */
export default function Do0070Controller(
    accesManager: IAccesManager,
    exLibelleFilter: IFilterLibelle,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    ApiConfig: IApiConfig,
    MenuItemAction: IMenuItemActionClass,
    $window: IWindowService,
    notificationHandler: INotificationHandler,
    $mdDialog: IDialogService,
    DialogStatus: IDialogAllStatus,
    ecranDetails: IEcranDetailsResourcesEntite,
) {

    const vm: IPageDo0070 = this;
    vm.valeursEcran = ecranDetails.valeurs;

    vm.formData = {};

    vm.icones = {
        telephonePrincipal: 'call',
        telephoneUrgence: 'health_and_safety',
        informationBancaires: 'attach_money',
        information: 'information',
        courriel: 'mail',
        adresseDomicile: 'home',
        feedback: 'feedback',
        motdepasse: 'password',
        questionSecrete: 'feedback',
        nomPrenom: 'account_circle',   // Icône pour nom & prénom
        fax: 'fax', // Icône Fax
        warning: 'warning'
    }

    vm.monoOccurrenceOptions = {
        //noId: true,
        lblBoutonEnregistrer: 'G_LBL_ACCES_PORTAIL',
        reloadPage: false,
        successActionSauvegarde: () => {
            vm.formData = vm.etwFormulaire?.data;// Initialiser notre tableau de données du formulaire
            lancerSimulationEtudiant();          
        },
        fonctions: {
            boutonDupliquer: false,
            suiviModification: false,
            supprime: false,
            exportation: false,
            skipChangementsNonSauvegardes: true,
            boutonEnregistrerHaut: true
        },
        menus: [

            new MenuItemAction(
                'G_LBL_ACCES_PORTAIL',
                'TRAITER_SIM',
                () => vm.formData,
                {
                    iconButton: false,
                    icon: 'subtitles',
                    secondaire: false,
                    hidden: false,
                    successAction: (_response: any, occurrence: any, _params: any, data: any) => {
                        vm.formData = occurrence.data;// Initialiser notre tableau de données du formulaire
                        lancerSimulationEtudiant();
                    }
                }
            )
        ],
        // Formulaire de saisie pour l'étudiant
        formulaire: new Formulaire('LBL_ETW', [
            new FormulaireItem('usrcleint', {
                largeur: 33
            }),
            new FormulaireItem('etwcleint', {
                largeur: 33
            }),
            
            new FormulaireItem('etwnummat', {
                largeur: 33
            }),
            new FormulaireItem('eplnummat', { // Matricule employé
                largeur: 33,
                maxlength:8
            }),
            new FormulaireItemSautDeLigne(),

            new FormulaireItem('etwnom', {
                largeur: 33
            }),
            new FormulaireItem('etwprn', {
                largeur: 33
            }),
            new FormulaireItem('etwadrcou', {
                largeur: 33
            }),
            new FormulaireItem('vaeeplsex', {
                largeur: 33
            }),
            new FormulaireItem('etwdatnai', {
                largeur: 33
            }),
            new FormulaireItemSautDeLigne(),


            new FormulaireItem('etwadrl01', {
                largeur: 33
            }),
            new FormulaireItem('etwadrl02', {
                largeur: 33
            }),
            new FormulaireItem('etwadrl03', {
                largeur: 33
            }),
            new FormulaireItem('pyscleint', {
                largeur: 33
            }),
            new FormulaireItem('etwpay', {
                largeur: 33
            }),
            new FormulaireItem('etacleint', {
                largeur: 33
            }),
            new FormulaireItem('etwpro', {
                largeur: 33
            }),
            new FormulaireItem('muncleint', {
                largeur: 33
            }),
            new FormulaireItem('etwvil', {
                largeur: 33
            }),
            new FormulaireItem('etwcodpos', {
                largeur: 33
            }),
            new FormulaireItem('etwnumtel', {
                largeur: 33
            }),
            new FormulaireItemSautDeLigne(),


            new FormulaireItem('etwflgimm', {
                largeur: 33
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('etwnas', {
                largeur: 33
            }),
            new FormulaireItem('etwnasimm', {
                largeur: 33
            }),
            new FormulaireItem('etwdatper', {
                largeur: 33
            }),
            new FormulaireItem('etwdatexp', {
                largeur: 33
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('apisimulation', {
                default: urlApiPortailEmploye(), // Récupération automatique de l'api du portail employé pour la simulation
                readonly: true
            }),
            new FormulaireItem('urlportail', {
                default: urlPortailEmploye(),   // Récupération automatique de l'url du portail employé
                readonly: true
            }),
            new FormulaireItem('simulation')


        ], { largeurDefaut: 50 })

    };

    //Retourner url de l'api
    function urlApiPortailEmploye() {
        let url = `${ApiConfig.ROOT}/login-ext/simulation`
        .replace('sofe', 'portail-employe')
        .replace(':443', '');
        return url;
    };

    //Retourner url du portail
    function urlPortailEmploye() {

        if (`${ApiConfig.ROOT}`.includes('localhost')) {
            return `${ApiConfig.ROOT}/login-ext`
                .replace('/sofe/', '/portail-employe/')
                .replace('8080', '3000')
                .replace(/\/api\//g, '/');
        }

        if (`${ApiConfig.ROOT}`.includes('siga-')) {
            return `${ApiConfig.ROOT}/login-ext`
                .replace('/sofe/', '/frontend/portail-employe/')
                .replace(/\/api\//g, '/');
        }

        return `${ApiConfig.ROOT}/login-ext`
            .replace('/safirh/', '/portail-employe/')
            .replace('/sofe/', '/portail-employe/')
            .replace(/\/api\//g, '/')
            .replace(':443', '');
    };


    function lancerSimulationEtudiant() {
        vm.enChargement = true;
        vm.messageErreur = null;
        vm.messageSucces = null;

        accesManager.lancerSimulationEtudiant_v2(
            urlApiPortailEmploye(),
            vm.formData as IEtw // cast contrôlé  ---- Donnée de champ accessible sous la forme : vm.formData.NomDuChamp
        )
            .then(() => {

                vm.messageSucces = `Vous pouvez accéder au portail employé pour l'étudiant : ${vm.formData.etwnummat}`;

                // Ouverture de la fenetre du Portail employé
                $window.open(urlPortailEmploye(), '_blank');

            })
            .catch(handleEchec)
            .finally(() => {
                vm.enChargement = false;
            });
    };

    function handleEchec(response: any) {
        // Essaye de récupérer un message pertinent renvoyé par le backend
        const backendMessage =
            response?.data?.message
            || response?.data?.error
            || response?.statusText;

        vm.messageErreur = backendMessage || exLibelleFilter('G_MSG_CHARG');

        afficherValidationErreur(response);
    }

    function afficherValidationErreur(error: IApiError) {
        const message = exLibelleFilter('G_MSG_PREREQUIS_PORTAIL');
        notificationHandler.erreur({
            error,
            lblTitre: 'G_LBL_FSA_CYCLE_EVENT',
            lblMessage: message
        });
        $mdDialog.hide(DialogStatus.APPLIQUER);
        $mdDialog.cancel(-2);
    }

}